import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@dev/ee-components';
import { OnboardingIntroWrapper } from './styles';

export const OnboardingIntro = () => {
    const { t } = useTranslation();
    return (
        <OnboardingIntroWrapper>
            <Typography variant="h2">{t('onboardingintro_title')}</Typography>
            <Typography variant="body1">{t('onboardingintro_desc')}</Typography>
        </OnboardingIntroWrapper>
    );
};
